import { render, staticRenderFns } from "./ProductVariantFormItems.vue?vue&type=template&id=1e20a734&"
import script from "./ProductVariantFormItems.vue?vue&type=script&lang=js&"
export * from "./ProductVariantFormItems.vue?vue&type=script&lang=js&"
import style0 from "./ProductVariantFormItems.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e20a734')) {
      api.createRecord('1e20a734', component.options)
    } else {
      api.reload('1e20a734', component.options)
    }
    module.hot.accept("./ProductVariantFormItems.vue?vue&type=template&id=1e20a734&", function () {
      api.rerender('1e20a734', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProductVariantFormItems.vue"
export default component.exports